import React from 'react'

import CardWithButtons from 'pages/Dashboard/CardWithButtons'

import AlertIcon from 'pages/shared/Alert/Icon'

import { color } from 'styles/colors'

type Props = {
  criticalAlertCount: number | string
  majorAlertCount: number | string
  minorAlertCount: number | string
  isLoaded: boolean
}

const EquipmentAlertsCard = ({ criticalAlertCount, majorAlertCount, minorAlertCount, isLoaded }: Props) => (
  <CardWithButtons
    title="Equipment Alerts"
    description="Equipment Alerts are triggered within the thermostat or HVAC equipment"
    image="/img/equipment_alerts.png"
    buttons={[
      {
        text: 'Critical Alerts',
        icon: <AlertIcon severity="critical" size="32px" />,
        quantity: criticalAlertCount,
        accentColor: color('criticalAlert'),
        apptentiveEventName: 'view_critical_alerts_customers',
        filter: 'critical',
        tooltip: 'Total number of "critical" alerts identified on registered or opted-in customers\' systems.'
      },
      {
        text: 'Major Alerts',
        icon: <AlertIcon severity="major" size="32px" />,
        quantity: majorAlertCount,
        accentColor: color('majorAlert'),
        apptentiveEventName: 'view_major_alerts_customers',
        filter: 'major',
        tooltip: 'Total number of "major" alerts identified on registered or opted-in customers\' systems.'
      },
      {
        text: 'Minor Alerts',
        icon: <AlertIcon severity="minor" size="32px" />,
        quantity: minorAlertCount,
        accentColor: color('minorAlert'),
        apptentiveEventName: 'view_minor_alerts_customers',
        filter: 'minor',
        tooltip: 'Total number of "minor" alerts identified on registered or opted-in customers\' systems.'
      }
    ]}
    isLoaded={isLoaded}
  />
)

export default EquipmentAlertsCard
